import React from "react";
import { Box, Typography } from "@material-ui/core";

const ColorsComponent = () => {
  return (
    <Box style={{ display: "grid", gap: "1.5rem", padding: "0 40px" }}>
      <Box
        className="d-flex align-items-center flex-wrap"
        style={{ gap: "1.5rem" }}
      >
        <Box className="d-flex align-items-center">
          <span
            style={{
              backgroundColor: "var(--primary)",
              display: "block",
              width: "25px",
              height: "25px",
              marginRight: "10px",
              borderRadius: "5px",
            }}
          ></span>
          <Typography variant="body1">Primary (#A18DBA)</Typography>
        </Box>
        <Box className="d-flex align-items-center">
          <span
            style={{
              backgroundColor: "var(--secondary)",
              display: "block",
              width: "25px",
              height: "25px",
              marginRight: "10px",
              borderRadius: "5px",
            }}
          ></span>
          <Typography variant="body1">Secondary (#1D1A21)</Typography>
        </Box>
        <Box className="d-flex align-items-center">
          <span
            style={{
              backgroundColor: "var(--accent)",
              display: "block",
              width: "25px",
              height: "25px",
              marginRight: "10px",
              borderRadius: "5px",
            }}
          ></span>
          <Typography variant="body1">Accent (#B444CB)</Typography>
        </Box>
        <Box className="d-flex align-items-center">
          <span
            style={{
              backgroundColor: "var(--success)",
              display: "block",
              width: "25px",
              height: "25px",
              marginRight: "10px",
              borderRadius: "5px",
            }}
          ></span>
          <Typography variant="body1">Success (#AACD34)</Typography>
        </Box>
        <Box className="d-flex align-items-center">
          <span
            style={{
              backgroundColor: "var(--info)",
              display: "block",
              width: "25px",
              height: "25px",
              marginRight: "10px",
              borderRadius: "5px",
            }}
          ></span>
          <Typography variant="body1">Info (#1B84FF)</Typography>
        </Box>
        <Box className="d-flex align-items-center">
          <span
            style={{
              backgroundColor: "var(--warning)",
              display: "block",
              width: "25px",
              height: "25px",
              marginRight: "10px",
              borderRadius: "5px",
            }}
          ></span>
          <Typography variant="body1">Warning (#FFC107)</Typography>
        </Box>
        <Box className="d-flex align-items-center">
          <span
            style={{
              backgroundColor: "var(--danger)",
              display: "block",
              width: "25px",
              height: "25px",
              marginRight: "10px",
              borderRadius: "5px",
            }}
          ></span>
          <Typography variant="body1">Danger (#CA310B)</Typography>
        </Box>
      </Box>

      <Box
        className="d-flex align-items-center flex-wrap"
        style={{ gap: "1.5rem" }}
      >
        <Box className="d-flex align-items-center">
          <span
            style={{
              backgroundColor: "var(--primary-color)",
              display: "block",
              width: "25px",
              height: "25px",
              marginRight: "10px",
              borderRadius: "5px",
            }}
          ></span>
          <Typography variant="body1">Primary Color (#A18DBA)</Typography>
        </Box>
        <Box className="d-flex align-items-center">
          <span
            style={{
              backgroundColor: "var(--light-primary)",
              display: "block",
              width: "25px",
              height: "25px",
              marginRight: "10px",
              borderRadius: "5px",
            }}
          ></span>
          <Typography variant="body1">Light Primary (#F2ECFA)</Typography>
        </Box>
        <Box className="d-flex align-items-center">
          <span
            style={{
              backgroundColor: "var(--dark-primary)",
              display: "block",
              width: "25px",
              height: "25px",
              marginRight: "10px",
              borderRadius: "5px",
            }}
          ></span>
          <Typography variant="body1">Dark Primary (#5E057E)</Typography>
        </Box>
      </Box>

      <Box
        className="d-flex align-items-center flex-wrap"
        style={{ gap: "1.5rem" }}
      >
        <Box className="d-flex align-items-center">
          <span
            style={{
              backgroundColor: "var(--secondary-color)",
              display: "block",
              width: "25px",
              height: "25px",
              marginRight: "10px",
              borderRadius: "5px",
            }}
          ></span>
          <Typography variant="body1">Secondary Color (#1D1A21)</Typography>
        </Box>
        <Box className="d-flex align-items-center">
          <span
            style={{
              backgroundColor: "var(--light-secondary)",
              display: "block",
              width: "25px",
              height: "25px",
              marginRight: "10px",
              borderRadius: "5px",
            }}
          ></span>
          <Typography variant="body1">Light Secondary (#1D1A216E)</Typography>
        </Box>
        <Box className="d-flex align-items-center">
          <span
            style={{
              backgroundColor: "var(--dark-secondary)",
              display: "block",
              width: "25px",
              height: "25px",
              marginRight: "10px",
              borderRadius: "5px",
            }}
          ></span>
          <Typography variant="body1">Dark Secondary (#121014)</Typography>
        </Box>
      </Box>

      <Box
        className="d-flex align-items-center flex-wrap"
        style={{ gap: "1.5rem" }}
      >
        <Box className="d-flex align-items-center">
          <span
            style={{
              backgroundColor: "var(--accent-color)",
              display: "block",
              width: "25px",
              height: "25px",
              marginRight: "10px",
              borderRadius: "5px",
            }}
          ></span>
          <Typography variant="body1">Accent Color (#B444CB)</Typography>
        </Box>
        <Box className="d-flex align-items-center">
          <span
            style={{
              backgroundColor: "var(--light-accent)",
              display: "block",
              width: "25px",
              height: "25px",
              marginRight: "10px",
              borderRadius: "5px",
            }}
          ></span>
          <Typography variant="body1">Light Accent (#B444D11A)</Typography>
        </Box>
        <Box className="d-flex align-items-center">
          <span
            style={{
              backgroundColor: "var(--dark-accent)",
              display: "block",
              width: "25px",
              height: "25px",
              marginRight: "10px",
              borderRadius: "5px",
            }}
          ></span>
          <Typography variant="body1">Dark Accent (#A53DBA)</Typography>
        </Box>
      </Box>

      <Box
        className="d-flex align-items-center flex-wrap"
        style={{ gap: "1.5rem" }}
      >
        <Box className="d-flex align-items-center">
          <span
            style={{
              backgroundColor: "var(--primary-text)",
              display: "block",
              width: "25px",
              height: "25px",
              marginRight: "10px",
              borderRadius: "5px",
            }}
          ></span>
          <Typography variant="body1">Primary Text (#110813)</Typography>
        </Box>
        <Box className="d-flex align-items-center">
          <span
            style={{
              backgroundColor: "var(--secondary-text)",
              display: "block",
              width: "25px",
              height: "25px",
              marginRight: "10px",
              borderRadius: "5px",
            }}
          ></span>
          <Typography variant="body1">Secondary Text (#4B5675)</Typography>
        </Box>
        <Box className="d-flex align-items-center">
          <span
            style={{
              backgroundColor: "var(--accent-text)",
              display: "block",
              width: "25px",
              height: "25px",
              marginRight: "10px",
              borderRadius: "5px",
            }}
          ></span>
          <Typography variant="body1">Accent Text (#979797)</Typography>
        </Box>
        <Box className="d-flex align-items-center">
          <span
            style={{
              backgroundColor: "var(--hint-text)",
              display: "block",
              width: "25px",
              height: "25px",
              marginRight: "10px",
              borderRadius: "5px",
            }}
          ></span>
          <Typography variant="body1">Hint Text (#99A1B7)</Typography>
        </Box>
      </Box>

      <Box
        className="d-flex align-items-center flex-wrap"
        style={{ gap: "1.5rem" }}
      >
        <Box className="d-flex align-items-center">
          <span
            style={{
              backgroundColor: "var(--border)",
              display: "block",
              width: "25px",
              height: "25px",
              marginRight: "10px",
              borderRadius: "5px",
            }}
          ></span>
          <Typography variant="body1">Border (#DBDFE9)</Typography>
        </Box>
        <Box className="d-flex align-items-center">
          <span
            style={{
              backgroundColor: "var(--field-bg)",
              display: "block",
              width: "25px",
              height: "25px",
              marginRight: "10px",
              borderRadius: "5px",
            }}
          ></span>
          <Typography variant="body1">Field BG (#DBDFE9)</Typography>
        </Box>
        <Box className="d-flex align-items-center">
          <span
            style={{
              backgroundColor: "var(--grey-text)",
              display: "block",
              width: "25px",
              height: "25px",
              marginRight: "10px",
              borderRadius: "5px",
            }}
          ></span>
          <Typography variant="body1">Grey Text (#808080)</Typography>
        </Box>
        <Box className="d-flex align-items-center">
          <span
            style={{
              backgroundColor: "var(--gray-bg)",
              display: "block",
              width: "25px",
              height: "25px",
              marginRight: "10px",
              borderRadius: "5px",
            }}
          ></span>
          <Typography variant="body1">Gray BG (#F1F1F4)</Typography>
        </Box>

        <Box className="d-flex align-items-center">
          <span
            style={{
              backgroundColor: "var(--light)",
              display: "block",
              width: "25px",
              height: "25px",
              marginRight: "10px",
              borderRadius: "5px",
            }}
          ></span>
          <Typography variant="body1">Light (#F8F9FA)</Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default ColorsComponent;
